<template>
  <div>
    <CRow>
      <CCol col="12" md="12" lg="12">
        <h4>
          <strong>{{ $store.state.form.dataTunjangan }}</strong>
        </h4>
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <b-form>
          <b-form-group :label="$store.state.form.namaTunjangan" label-cols-md="3">
            <b-form-select :options="tunTetap" v-model="dataTT.masterTunjanganId" @input="setNominal(dataTT.masterTunjanganId)"></b-form-select>
          </b-form-group>
        </b-form>

        <b-form>
          <b-form-group :label="$store.state.form.nominalTunjangan" label-cols-md="3">
            <b-form-input v-model="dataTT.nominalTunjangan"></b-form-input>
          </b-form-group>
        </b-form>

        <b-form>
          <b-form-group :label="$store.state.form.keterangan" label-cols-md="3">
            <b-form-textarea v-model="dataTT.keterangan"></b-form-textarea>
          </b-form-group>
        </b-form>

        <b-button variant="primary" @click="simpan()"> <CIcon name="cil-plus" /> {{ $store.state.form.tambahData }} </b-button>
      </CCol>
    </CRow>

    <CRow class="mt-3">
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #actions="{ item }">
            <td>
              <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipHapus" v-b-modal.modal-delete-tunj @click="dataTunjangan = item">
                <CIcon name="cil-trash" />
              </b-button>
            </td>
          </template>
        </CDataTable>
      </CCol>
    </CRow>

    <modal-delete :dataTunjangan="dataTunjangan" @alert="triggerAlert($event), getDatas()" />
  </div>
</template>

<script>
import modalDelete from "./modalDelete.vue";
export default {
  components: {
    modalDelete,
  },
  props: ["data", "activeTab"],
  data() {
    return {
      jdt: ["bulan", "hari"],
      items: [],
      dataTunjangan: {},
      dataTT: {
        masterTunjanganId: "",
        nominalTunjangan: "",
        // durasiTunjangan: null,
        // jenisDurasiTunjangan: "bulan",
        // tglAwalTunjangan: "",
        keterangan: "",
      },
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sorter: true,
          class: "table-number text-center",
        },
        {
          key: "namaTunjangan",
          label: "Nama Tunjangan",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "nominalTunjangan",
          label: "Nominal Tunjangan",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "keterangan",
          label: "Keterangan",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "actions",
          label: "Actions",
          class: "table-option-3 text-center",
        },
      ],
      tunTetap: [],
      tableBusy: false,
    };
  },
  computed: {},

  watch: {
    "data.dataKaryawanId"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getDatas();
      }
    },
    activeTab(newVar) {
      if (newVar == 2) {
        this.getDatas();
      }
    },
  },
  methods: {
    setNominal(x) {
      this.tunTetap.forEach((item) => {
        if (item.masterTunjanganId == x) {
          this.dataTT.nominalTunjangan = item.nominalTunjangan;
        }
      });
    },
    async getDatas() {
      let vm = this;
      let tunTetap = await vm.$axios.post("masterTunjangan/list");

      vm.tunTetap = tunTetap.data.data.map((item) => {
        return { ...item, value: item.masterTunjanganId, text: item.namaTunjangan };
      });

      let tunKaryawan = await vm.$axios.post("poolTunjangan/listPoolTunjanganByDataKaryawanId/", { dataKaryawanId: vm.$route.query.dataKaryawanId });
      // console.log('tunKaryawan', tunKaryawan);
      vm.items =
        tunKaryawan.data.status == 200
          ? tunKaryawan.data.data.map((x, idx) => {
              return {
                ...x,
                no: idx + 1,
              };
            })
          : [];
    },
    simpan() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      vm.dataTT.dataKaryawanId = vm.data.dataKaryawanId;
      vm.$axios
        .post("poolTunjangan/register", vm.dataTT)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.triggerAlert({
              variant: "success",
              msg: "TERJADI KESALAHAN PADA TUNJANGAN",
              showing: true,
            });
            // vm.variant = "success";
            // vm.msg = "BERHASIL MENDAFTARKAN TUNJANGAN";
            // vm.showing = true;
            // setTimeout(() => {
            //   vm.showing = false;
            // }, 4000);
            this.dataTT = {
              masterTunjanganTetapId: "",
              nominalTunjangan: "",
            };
            this.getDatas();
            vm.$emit("change");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.triggerAlert({
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
            // vm.variant = "danger";
            // vm.msg = _.toUpper(res.data.message);
            // vm.showing = true;
            // setTimeout(() => {
            //   vm.showing = false;
            // }, 4000);
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.triggerAlert({
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
          // vm.variant = "danger";
          // vm.msg = "TERJADI KESALAHAN PADA SERVER";
          // vm.showing = true;
          // setTimeout(() => {
          //   vm.showing = false;
          // }, 4000);
        });
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.$emit("change");
    },
  },
};
</script>
